import { InvoiceDetails, RelatedService } from '../billing/billing.types';
import { RelatedServiceCard } from './RelatedServiceCard';

type RelatedServiceListProps = {
  relatedServices: RelatedService[];
  invoiceData?: InvoiceDetails;
};

export const RelatedServiceList = ({ relatedServices, invoiceData }: RelatedServiceListProps) => {
  return (
    <div className="flex flex-col gap-3">
      {relatedServices.map((service, index) => (
        <RelatedServiceCard key={index} relatedService={service} invoiceData={invoiceData} />
      ))}
    </div>
  );
};
